var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", [
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-column align-items-center align-items-sm-start h-100 aside_content",
      },
      [
        _c(
          "a",
          {
            staticClass: "d-flex align-items-center w-100 mb-4",
            attrs: { href: _vm.dashboardLink },
          },
          [
            _c("span", { staticClass: "aside_logo mx-auto" }, [
              _c("img", {
                staticClass: "img",
                staticStyle: {
                  "max-height": "80px",
                  width: "100%",
                  "object-fit": "contain",
                },
                attrs: { src: _vm.logoUrl },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "aside_menu custom-ul nav nav-pills w-100",
            attrs: { id: "menu" },
          },
          _vm._l(_vm.visibleLinks, function (item, index) {
            return _c("SidebarItem", {
              key: item.label + index,
              attrs: {
                link: item,
                index: index,
                links: _vm.links,
                fav_list: _vm.fav_list,
                history_list: _vm.history_list,
              },
              on: {
                addToFav: _vm.addToFav,
                removeFromFav: _vm.removeFromFav,
                getUserFavourites: _vm.getUserFavourites,
                getUserLinkHistories: _vm.getUserLinkHistories,
                handleChangeFavourites: _vm.handleChangeFavourites,
                removeSearchResult: _vm.removeSearchResult,
                addToLinkHistory: _vm.addToLinkHistory,
              },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center justify-content-end flex-column w-100 aside_footer_img mt-5",
          },
          [
            _c(
              "span",
              { staticClass: "aside_footer_logo" },
              [
                _c("img", {
                  staticClass: "mx-auto",
                  attrs: { src: "/assets/images/footerlogo.svg" },
                }),
                _vm._v(" "),
                _vm.version
                  ? _c(
                      "router-link",
                      {
                        staticClass: "version-link",
                        staticStyle: {
                          "text-align": "center",
                          "font-size": "14px",
                          "margin-top": "5px",
                          display: "block",
                          color: "#1d5166",
                          "text-decoration": "none",
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        },
                        attrs: { to: "/updates" },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.version) + "\n        "
                        ),
                      ]
                    )
                  : _c(
                      "p",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "font-size": "14px",
                          "margin-top": "5px",
                        },
                      },
                      [_vm._v("\n          ...\n        ")]
                    ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "aside_open_icon" }, [
      _c("i", { staticClass: "fas fa-angle-double-left" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }